export const metricKey = metric => JSON.stringify([metric.name.trim().toLowerCase(), metric.unit.trim().toLowerCase().replace(/[–—]/g, '-')]);
export const metricNumber = value => new Intl.NumberFormat('en-US', { maximumFractionDigits: 2 }).format(value);
export const metricDelta = (first, last) => Number.isFinite(first) && Number.isFinite(last) ? `${last - first > 0 ? '+' : ''}${metricNumber(last - first)}` : '—';
export const chronologicalEvaluations = evaluations => [...evaluations].sort((a, b) => a.date.localeCompare(b.date) || (a.created_at || '').localeCompare(b.created_at || '') || a.id.localeCompare(b.id));
export function metricSeries(evaluations) {
  const series = new Map();
  for (const evaluation of chronologicalEvaluations(evaluations)) {
    for (const metric of evaluation.metrics || []) {
      const key = metricKey(metric);
      if (!Number.isFinite(metric.value)) continue;
      if (!series.has(key)) series.set(key, { key, name: metric.name, unit: metric.unit, points: [] });
      series.get(key).points.push({ date: evaluation.date, value: metric.value, title: evaluation.title, trainer: evaluation.trainer_name, evaluation_id: evaluation.id });
    }
  }
  return [...series.values()];
}